// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"84":"40d30639","273":"039162ac","313":"48fb0781","453":"fd90c63d","486":"f3fbf288","519":"a55f8a26","927":"263e6fdb"}[chunkId] + ".chunk.js";
};